import $ from "jquery";
function debouncer(func, timeout) {
    var timeoutID;
    timeout = timeout || 20;
    return function () {
        var scope = this;
        var args = arguments;
        clearTimeout(timeoutID);
        timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
        }, timeout);
    };
}
export const backToTop = {
    init: function () {
        $(".js-floating").click(function (e) {
            e.preventDefault();
            let defaultDuration = 2600;
            if (window.pageYOffset < window.innerHeight * 2) {
                defaultDuration = 1000;
            }
            else if (window.pageYOffset < window.innerHeight * 5) {
                defaultDuration = 2000;
            }
            $("html, body").animate({
                scrollTop: 0,
            }, defaultDuration, function () {
                $(".js-floating").hide();
                return false;
            });
        });
        const handleScroll = debouncer(function () {
            backToTop.toggleWhen();
        }, 250);
        backToTop.toggleWhen();
        $(window).scroll(handleScroll);
    },
    toggleWhen: function () {
        if (window.pageYOffset > $("#header").height()) {
            $(".js-floating").show();
        }
        else {
            $(".js-floating").hide();
        }
    },
};
